<ng-template #mdlConfirmationDialog let-modal>
    <div class="container-fluid p-2">
        <div class="modal-body">
            <div class="justify-all-center w-100-p">
                <div class="mt-18-p "></div>
                <div class="confirm-dialog-content-position-img">
                  <img src="assets/icons/ico_warning_modal.svg" class="confirm-dialog-size-img" alt="warning">
                </div>
                <div class="confirm-dialog-content-position-message fw-w-bold">
                    {{confirmationDialog.message}} 
                </div>
                <hr class="line-h-blue-purple-dialogs-big-center">
        
                <ng-container *ngIf="confirmationDialog.messageTwo !== undefined">
                  <div class="confirm-dialog-content-position-message">
                    {{confirmationDialog.messageTwo}} 
                  </div>
                  <br>
                </ng-container>
        
                <br>

                <button type="button" class="btn btn-secondary" (click)="initializaDialog(2)">
                    {{'common.btnCancel' | translate }}
                </button>
                &nbsp;&nbsp;&nbsp;
                <button type="button" class="btn btn-info" (click)="initializaDialog(1)">
                    {{'common.btnConfirm' | translate }}
                </button>
            </div> 
            
        </div>

    </div>
</ng-template>
